export enum MFAStep {
  SEND_CODE = 'SEND_CODE',
  CHANGE_VERIFICATION_METHOD = 'CHANGE_VERIFICATION_METHOD',
}

export enum MFAChannelType {
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export interface MFAChannel {
  type?: MFAChannelType;
  value?: string;
  isDefault?: boolean;
  codeSentTimestamp?: number;
}

export interface MFAChannelPayload {
  type?: MFAChannelType;
  value?: string;
  is_default?: boolean;
}

export enum MFAError {
  CODE_IS_INVALID = 'Code is invalid',
  SESSION_HAS_EXPIRED = 'Your session has expired, please try logging in again.',
}

export enum MfaServerErrorText {
  USER_ACCOUNT_IS_LOCKED = 'user account is locked',
  SESSION_IS_EXPIRED = 'mfa session is incorrect',
}

export const REMEMBER_ME_DEVICE_TOKEN_COOKIE_KEY = 'REMEMBER_ME_DEVICE_TOKEN';
